var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoCircleYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/info-circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "info-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.99998 1.83325C4.32665 1.83325 1.33331 4.82659 1.33331 8.49992C1.33331 12.1733 4.32665 15.1666 7.99998 15.1666C11.6733 15.1666 14.6666 12.1733 14.6666 8.49992C14.6666 4.82659 11.6733 1.83325 7.99998 1.83325ZM7.49998 5.83325C7.49998 5.55992 7.72665 5.33325 7.99998 5.33325C8.27331 5.33325 8.49998 5.55992 8.49998 5.83325V9.16659C8.49998 9.43992 8.27331 9.66659 7.99998 9.66659C7.72665 9.66659 7.49998 9.43992 7.49998 9.16659V5.83325ZM8.61331 11.4199C8.57998 11.5066 8.53331 11.5733 8.47331 11.6399C8.40665 11.6999 8.33331 11.7466 8.25331 11.7799C8.17331 11.8133 8.08665 11.8333 7.99998 11.8333C7.91331 11.8333 7.82665 11.8133 7.74665 11.7799C7.66665 11.7466 7.59331 11.6999 7.52665 11.6399C7.46665 11.5733 7.41998 11.5066 7.38665 11.4199C7.35331 11.3399 7.33331 11.2533 7.33331 11.1666C7.33331 11.0799 7.35331 10.9933 7.38665 10.9133C7.41998 10.8333 7.46665 10.7599 7.52665 10.6933C7.59331 10.6333 7.66665 10.5866 7.74665 10.5533C7.90665 10.4866 8.09331 10.4866 8.25331 10.5533C8.33331 10.5866 8.40665 10.6333 8.47331 10.6933C8.53331 10.7599 8.57998 10.8333 8.61331 10.9133C8.64665 10.9933 8.66665 11.0799 8.66665 11.1666C8.66665 11.2533 8.64665 11.3399 8.61331 11.4199Z",
    fill: "#FEB101"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircleYellow);
export default __webpack_public_path__ + "static/media/info-circle-yellow.8a3180a0bf8774c3a6c862bf1ddd6f34.svg";
export { ForwardRef as ReactComponent };